import React from 'react'
import { View, Text } from '@react-pdf/renderer'
import { PropTypes } from 'prop-types'
import { themeConfig } from '../../config/theme.config'

const RightSectionTitle = ({ rightTitle, width, textAlign }) => {
  const boxRight = {
    width,
    borderRight: '1 solid grey',
    padding: '5pt',
    borderTop: '1 solid grey',
    backgroundColor: themeConfig.semcogBlue1,
    color: 'white',
    display: 'flex',
    justifyContent: 'center',
    fontSize: 12,
    textAlign,
    fontFamily: 'Roboto',
    fontWeight: 'bold'
  }
  //   const text = { padding: '5pt' };
  return (
    <View style={[boxRight]} wrap={false}>
      <Text>{rightTitle}</Text>
    </View>
  )
}

export default RightSectionTitle

RightSectionTitle.propTypes = {
  rightTitle: PropTypes.string.isRequired,
  width: PropTypes.string,
  textAlign: PropTypes.string
}
